"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATE_INPUT_ICONS = exports.secondaryVariantStyle = exports.primaryVariantStyle = exports.postcodeDefaultRegex = void 0;
var postcodeDefaultRegex = '^[a-zA-Z]{1,2}[0-9][a-zA-Z0-9]? ?[0-9][a-zA-Z]{2}$';
exports.postcodeDefaultRegex = postcodeDefaultRegex;
var primaryVariantStyle = 'primary';
exports.primaryVariantStyle = primaryVariantStyle;
var secondaryVariantStyle = 'secondary';
exports.secondaryVariantStyle = secondaryVariantStyle;
var DATE_INPUT_ICONS = {
  clock: 'clock'
};
exports.DATE_INPUT_ICONS = DATE_INPUT_ICONS;